






























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import fetch from '@/common/api/fetch';
import getUrlParam from '@/common/utils/getUrlParam';

import { AxiosPromiseData } from '@/common/interface';
import { Ladder, Group } from '@/common/interface/group_type';

import getActivityType from '@/common/utils/getActivityType';
import MyGroupModal from './MyGroupModal.vue';
import GroupActivitySection from '@/components/groupType/index/GroupActivitySection.vue';

const Ellipsis = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571312457209.png?x-oss-process=image/resize,w_300,limit_0';
const Arrow = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571312017264.png?x-oss-process=image/resize,w_300,limit_0';
const Grouped = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571312783117.png?x-oss-process=image/resize,w_300,limit_0';
const Grouping = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571312807977.png?x-oss-process=image/resize,w_300,limit_0';
const GroupFull = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571312651791.png?x-oss-process=image/resize,w_300,limit_0';

@Component({
  components: {
    'group-activity-section': GroupActivitySection,
    'my-group-modal': MyGroupModal
  }
})
export default class MyGroup extends Vue {
  @Getter('urlUid') urlUid!: string;
  @Getter('uid') uid!: string;
  @Getter('gradientColor') gradientColor!: string;
  @Getter('mainTextColor') mainTextColor!: string;
  @Getter('canPay') canPay!: boolean;
  @Getter('posterName') posterName!: string;
  @Getter('showJoinFooter') showJoinFooter!: boolean;
  // @Getter("ladderGroupList") ladderGroupList!: Ladder[];
  @Getter('courseGroupList') courseGroupList!: any;
  @Getter('selectedSeqNo') selectedSeqNo!: number;
  @Getter('section') section!: any;
  @Getter('hasPay') hasPay!: number;
  @Getter('cancel') cancel!: boolean;
  @Getter('startTime') startTime!: number;
  @Getter('nickname') nickname!: string;
  @Getter('avatar') avatar!: string;
  @Getter('deadline') deadline!: number;

  @Action('changeGroupFullStatus') changeGroupFullStatus!: Function;
  @Action('changeUrlUid') changeUrlUid!: Function;
  @Action('changePosterName') changePosterName!: Function;
  @Action('changePosterAvatar') changePosterAvatar!: Function;
  @Action('changeShowJoinFooter') changeShowJoinFooter!: Function;
  @Action('changeSelectedSeqNo') changeSelectedSeqNo!: Function;

  templateType: string = getActivityType() as string;
  myGroupList: Array<Group> = [];
  availableLadderList: Array<Ladder> = [];
  recentLadder: Ladder | undefined = {
    groupSize: '',
    groupPrice: ''
  };

  Ellipsis: string = Ellipsis;
  Arrow: string = Arrow;
  Grouped: string = Grouped;
  Grouping: string = Grouping;
  GroupFull: string = GroupFull;

  applyNum: number = 0;
  groupSize: number = 0;
  maxGroupSize: number = 0;

  showMyGroupModal: boolean = false;
  showCourseName: string = '';
  ladderGroupList: Ladder[] = [];

  currentPrgram() {
    const myGroup = this.myGroupList[0];
    const len = this.availableLadderList.length;
    return this.availableLadderList[this.availableLadderList.length - 1];
  }

  get currentPrice() {
    return this.currentPrgram().groupPrice;
  }

  get currentMember() {
    return this.currentPrgram().groupSize;
  }

  @Watch('urlUid')
  getGroupDetail() {
    if (!this.urlUid) {
      return;
    }
    setTimeout(() => {
      const param = {
        activityId: getUrlParam('broadcastId'),
        userId: this.urlUid
      };
      fetch.Sales('anon/distributeGroup/getCurrentGroup', param).then((res: AxiosPromiseData) => {
        
        const { result } = res;
        const { groupDetailVOS, groupSize, applyNum, maxGroupSize, seqNo = 1 } = result;
        this.showCourseName = this.courseGroupList[seqNo - 1].courseName;
        this.ladderGroupList = this.courseGroupList[seqNo - 1].ladderGroupList;
        this.changeSelectedSeqNo(seqNo);
        this.myGroupList = groupDetailVOS.filter((item: any) => {
          // -1:不需要支付 4:支付完成
          return item.payState === -1 || item.payState === 4;
        });
        this.applyNum = applyNum;
        this.groupSize = groupSize;
        this.maxGroupSize = maxGroupSize;
        if (groupDetailVOS.length > 0) {
          // 获取满足条件的阶梯方案
          this.getAvailableProgramList();
          const head = groupDetailVOS[0];
          const { payState, name, avatar } = head;
          if (payState !== 4 && payState !== -1) {
            if (this.uid) {
              this.changeUrlUid(this.uid);
            } else {
              this.changeUrlUid('');
            }
          } else {
            this.changePosterName(name);
            this.changePosterAvatar(avatar);
          }
          // 判断是否满团
          let groupFull = false;
          // 多阶拼团的情况下，已经报名人数和最大成团人数比较
          if (maxGroupSize) {
            groupFull = applyNum >= maxGroupSize;
          } else {
            groupFull = applyNum >= groupSize;
          }
          console.log(groupFull, 'groupFull');
          this.changeGroupFullStatus(groupFull);
        } else {
          Vue.$confirm({
            oneBtn: true,
            title: '很抱歉',
            text: '该团已被删除，请重新开团',
            okText: '确定'
          });
          if (this.uid) {
            this.changeUrlUid(this.uid);
          } else {
            this.changeUrlUid('');
          }
        }
      });
    }, 1000);
  }

  getAvailableProgramList() {
    this.availableLadderList = this.ladderGroupList.filter(ladder => ladder.groupSize <= this.applyNum);
    // 在任何一个阶梯中都找不到比已经报名参加的人数多的，那就说明当前报名参加的人数已经达到了最后一个阶梯，即已经满团了
    this.recentLadder = this.ladderGroupList.find(ladder => ladder.groupSize > this.applyNum);
  }

  // 显示/隐藏分享popup
  handleRedirectToSharePage() {
    // 跳转到小程序分享页面
    const broadcastId = getUrlParam('broadcastId');
    const posterName = this.posterName;
    const origin = getUrlParam('origin');
    // 如果是从独立版小麦秀小程序进入的分享页,那么分享的时候就跳到独立版小麦秀的分享页
    if (origin === 'ordinary') {
      window.wx.miniProgram.redirectTo({
        url: `/pages/activity/activityShare/main?id=${broadcastId}&parentUid=${this.urlUid}`
      });
    } else {
      window.wx.miniProgram.redirectTo({
        url: `/pages/user-share/index?broadcastId=${broadcastId}&parentUid=${this.urlUid}&name=${posterName}`
      });
    }
  }
  toInvite() {
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error('活动未开始');
    } else {
      if (this.nickname) {
        const broadcastId = getUrlParam('broadcastId');
        const distributorId = getUrlParam('distributorId');
        const scene = `activityId=${broadcastId}&templateType=${this.templateType}&nickname=${this.nickname}&avatar=${this.avatar}&distributorId=${distributorId ? `${distributorId}` : `-1`}&parentUid=${this.urlUid}`;
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.navigateTo({
            url: `/pages/poster/index?${scene}`
          });
        }
      }
    }
  }
  handleToggleMyGroupModal() {
    this.showMyGroupModal = !this.showMyGroupModal;
  }
}
